import {User} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const PersonIcon = createLucideIcon(User, 'PersonIcon');
